import DataPill from "@components/pills/DataPill";
import React from "react";

interface StatusPillRendererProps {
  status?: string;
  params?: any;
}

interface AgGridParams {
  data: any;
  value?: string;
  [key: string]: any;
}

export const StatusPillRenderer: React.FC<
  StatusPillRendererProps | AgGridParams
> = (props: any) => {
  const isAgGridCall =
    props &&
    typeof props === "object" &&
    "data" in props &&
    !("status" in props || "params" in props);

  let finalStatus: string | undefined;

  if (isAgGridCall) {
    finalStatus = props.data?.status || props.value;
  } else {
    const { status, params } = props as StatusPillRendererProps;
    finalStatus = status || params?.data?.status || params?.status;
  }

  return (
    <div className="flex items-center h-full">
      <DataPill value={finalStatus} label={finalStatus ? undefined : "UNKNOWN"} />
    </div>
  );
};
